import { createEvent } from 'effector';

export const putEconomicsDataEv = createEvent();
